import { cva } from 'class-variance-authority';

export type FieldSize = 'default' | 'sm' | 'xs';

/**
 * Sizing recipe for box-style fields (Input, Select trigger): height,
 * horizontal padding, and body typography.
 */
export const fieldSizeVariants = cva('', {
  variants: {
    size: {
      default: 'eye:h-48 eye:px-16 eye:body-m',
      sm: 'eye:h-[40px] eye:px-12 eye:body-s',
      xs: 'eye:h-32 eye:px-12 eye:body-s',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

/**
 * Sizing recipe for multi-line fields (Textarea): horizontal/vertical padding
 * and body typography. No fixed height — the field grows with its content.
 */
export const textareaSizeVariants = cva('', {
  variants: {
    size: {
      default: 'eye:px-16 eye:py-12 eye:body-m',
      sm: 'eye:px-12 eye:py-8 eye:body-s',
      xs: 'eye:px-12 eye:py-4 eye:body-s',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

/**
 * Sizing recipe for the Combobox trigger container (an `InputGroup`), which
 * carries its own min-height rather than a fixed height.
 */
export const comboboxTriggerSizeVariants = cva('', {
  variants: {
    size: {
      default: '',
      sm: 'eye:min-h-[40px]!',
      xs: 'eye:min-h-32!',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

/**
 * Sizing recipe for the inner Combobox trigger button, whose min-height sits
 * 2px inside the trigger container's border.
 */
export const comboboxTriggerButtonSizeVariants = cva('', {
  variants: {
    size: {
      default: '',
      sm: 'eye:min-h-[38px]! eye:text-14!',
      xs: 'eye:min-h-[30px]! eye:text-14!',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});
